export function containsKey(key: string, categoryList: Array<string>) {
  return categoryList.includes(key.toLowerCase());
}
